import { HolidaysByCountry, IFilterFields, IFilterFieldsEntryBoolean, IFilterFieldsEntryDate, IFilterFieldsEntryEnum, IFilterFieldsEntryNumber, IFilterFieldsEntryStringArray } from './interface'

/* eslint-disable no-bitwise */

export const defaultPageSize = 25
export const pageSizeMultiplier = 2
// since bewotec can't handle changing pageSizes we need this "workaround"
export const initialPageSize = defaultPageSize * pageSizeMultiplier
export const defaultAverageLineHeight = 75
export const validPaxes = ['0', '1', '2', '3', '4', '5']

export class DefaultValues implements IFilterFields {
  departureDate: IFilterFieldsEntryDate
  arrivalDate: IFilterFieldsEntryDate
  duration: IFilterFieldsEntryNumber
  campaigns: IFilterFieldsEntryStringArray
  regions: IFilterFieldsEntryStringArray
  ports: IFilterFieldsEntryStringArray
  isStartPort: IFilterFieldsEntryBoolean
  isEndPort: IFilterFieldsEntryBoolean
  cruiseAttributes: IFilterFieldsEntryStringArray
  airports: IFilterFieldsEntryStringArray
  hasFlexFlight: IFilterFieldsEntryBoolean
  hasHigherFlightClasses: IFilterFieldsEntryBoolean
  ships: IFilterFieldsEntryStringArray
  categories: IFilterFieldsEntryStringArray
  priceModels: IFilterFieldsEntryStringArray
  adults: IFilterFieldsEntryEnum
  juveniles: IFilterFieldsEntryEnum
  children: IFilterFieldsEntryEnum
  babies: IFilterFieldsEntryEnum
  constructor() {
    this.departureDate = { type: 'date', enum: null, value: '' }
    this.arrivalDate = { type: 'date', enum: null, value: '' }
    this.duration = { type: 'flags', enum: null, value: 0 }
    this.campaigns = { type: 'flags', enum: null, value: [] }
    this.regions = { type: 'flags', enum: null, value: [] }
    this.ports = { type: 'flags', enum: null, value: [] }
    this.isStartPort = { type: 'boolean', enum: null, value: false }
    this.isEndPort = { type: 'boolean', enum: null, value: false }
    this.cruiseAttributes = { type: 'flags', enum: null, value: [] }
    this.airports = { type: 'flags', enum: null, value: [] }
    this.hasFlexFlight = { type: 'boolean', enum: null, value: false }
    this.hasHigherFlightClasses = { type: 'boolean', enum: null, value: false }
    this.ships = { type: 'flags', enum: null, value: [] }
    this.categories = { type: 'flags', enum: null, value: [] }
    this.priceModels = { type: 'flags', enum: null, value: [] }
    // TODO: Paxes don't need enums any more.
    this.adults = { type: 'enum', enum: validPaxes, value: '2' }
    this.juveniles = { type: 'enum', enum: validPaxes, value: '0' }
    this.children = { type: 'enum', enum: validPaxes, value: '0' }
    this.babies = { type: 'enum', enum: validPaxes, value: '0' }
  }
}

export default new DefaultValues()

export const holidayDefaultValues: HolidaysByCountry = 
  {
    'DE': {
      countryName: 'Deutschland',
      selected: false,
      holidays: [],
      federalStates: {
        'BB': {
          stateName: 'Brandenburg',
          selected: false,
        },
        'BE': {
          stateName: 'Berlin',
          selected: false,
        },
        'BW': {
          stateName: 'Baden-Württemberg',
          selected: false,
        },
        'BY': {
          stateName: 'Bayern',
          selected: false,
        },
        'HB': {
          stateName: 'Bremen',
          selected: false,
        },
        'HE': {
          stateName: 'Hessen',
          selected: false,
        },
        'HH': {
          stateName: 'Hamburg',
          selected: false,
        },
        'MV': {
          stateName: 'Mecklenburg-Vorpommern',
          selected: false,
        },
        'NI': {
          stateName: 'Niedersachsen',
          selected: false,
        },
        'NW': {
          stateName: 'Nordrhein-Westfalen',
          selected: false,
        },
        'RP': {
          stateName: 'Rheinland-Pfalz',
          selected: false,
        },
        'SH': {
          stateName: 'Schleswig-Holstein',
          selected: false,
        },
        'SL': {
          stateName: 'Saarland',
          selected: false,
        },
        'SN': {
          stateName: 'Sachsen',
          selected: false,
        },
        'ST': {
          stateName: 'Sachsen-Anhalt',
          selected: false,
        },
        'TH': {
          stateName: 'Thüringen',
          selected: false,
        },
      }
    },
    'AT': {
      countryName: 'Österreich',
      selected: false,
      holidays: [],
      federalStates: {
        'BL': {
          stateName: 'Burgenland',
          selected: false,
        },
        'KÄ': {
          stateName: 'Kärnten',
          selected: false,
        },
        'NÖ': {
          stateName: 'Niederösterreich',
          selected: false,
        },
        'OÖ': {
          stateName: 'Oberösterreich',
          selected: false,
        },
        'SB': {
          stateName: 'Salzburg',
          selected: false,
        },
        'SM': {
          stateName: 'Steiermark',
          selected: false,
        },
        'TI': {
          stateName: 'Tirol',
          selected: false,
        },
        'VA': {
          stateName: 'Vorarlberg',
          selected: false,
        },
        'WI': {
          stateName: 'Wien',
          selected: false,
        }
      }
    },
    'CH': {
      countryName: 'Schweiz',
      selected: false,
      holidays: [],
      federalStates: {
        'AG': {
          stateName: 'Aargau',
          selected: false,
        },
        'AI': {
          stateName: 'Appenzell Innerrhoden',
          selected: false,
        },
        'AR': {
          stateName: 'Appenzell Ausserrhoden',
          selected: false,
        },
        'BE': {
          stateName: 'Bern',
          selected: false,
        },
        'BL': {
          stateName: 'Basel-Landschaft',
          selected: false,
        },
        'BS': {
          stateName: 'Basel-Stadt',
          selected: false,
        },
        'FR': {
          stateName: 'Freiburg',
          selected: false,
        },
        'GE': {
          stateName: 'Genf',
          selected: false,
        },
        'GL': {
          stateName: 'Glarus',
          selected: false,
        },
        'GR': {
          stateName: 'Graubünden',
          selected: false,
        },
        'JU': {
          stateName: 'Jura',
          selected: false,
        },
        'LU': {
          stateName: 'Luzern',
          selected: false,
        },
        'NE': {
          stateName: 'Neuenburg',
          selected: false,
        },
        'NW': {
          stateName: 'Nidwalden',
          selected: false,
        },
        'OW': {
          stateName: 'Obwalden',
          selected: false,
        },
        'SG': {
          stateName: 'St. Gallen',
          selected: false,
        },
        'SH': {
          stateName: 'Schaffhausen',
          selected: false,
        },
        'SO': {
          stateName: 'Solothurn',
          selected: false,
        },
        'SZ': {
          stateName: 'Schwyz',
          selected: false,
        },
        'TG': {
          stateName: 'Thurgau',
          selected: false,
        },
        'TI': {
          stateName: 'Tessin',
          selected: false,
        },
        'UR': {
          stateName: 'Uri',
          selected: false,
        },
        'VD': {
          stateName: 'Waadt',
          selected: false,
        },
        'VS': {
          stateName: 'Wallis',
          selected: false,
        },
        'ZG': {
          stateName: 'Zug',
          selected: false,
        },
        'ZH': {
          stateName: 'Zürich',
          selected: false,
        },
      }
    },
  }
